import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useAuth } from 'context'

import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { color } from 'config/color'
import { ServiceButtonGroup, UsageView } from './components'
import QuickLinks from 'components/layouts/AuthorizedLayout/component/QuickLinks'

export const Usage: React.FC = () => {
  const { services } = useAuth()
  const [serviceType, setServiceType] = useState<string>(
    services[0]?.toLowerCase()
  )
  const isMobile = useMobileBreakpoints()

  return (
    <>
      {isMobile && <QuickLinks />}

      {serviceType && (
        <>
          {services.length > 1 && (
            <Box mt={3}>
              <Typography fontSize={24} color={color.black} fontWeight={500}>
                Select a Service to visualize:
              </Typography>

              <ServiceButtonGroup
                serviceType={serviceType}
                setServiceType={setServiceType}
              />
            </Box>
          )}

          <UsageView serviceType={serviceType} />
        </>
      )}
    </>
  )
}
